var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"number-input"},[_c('button',{on:{"click":_vm.decrease}},[_vm._v("-")]),_c('input',{attrs:{"type":"number","step":"1","min":"0"},domProps:{"value":_vm.value},on:{"input":_vm.onInput,"keydown":_vm.onKeydown}}),_c('button',{on:{"click":_vm.increase}},[_vm._v("+")])])
}
var staticRenderFns = []

export { render, staticRenderFns }